export function setOptionsValue(target: Ref<any>, key: string, props: any, options: object, defValue :any = null) {
  target.value = getOptionsValue(key, props, options, defValue)
}

export function getOptionsValue(key: string, props: any, options: object, defValue :any = null) {
  if (props && key in props && props[key]) {
    return props[key]
  } else if (options && key in options && options[key]) {
    return options[key]
  } else if (defValue !== null) {
    return defValue
  } else {
    return null
  }
}
